(() => {
  if (customElements.get('gp-pairing-card')) return;
  class PairingCard extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[name="add"]');
      this.status = this.querySelector('[data-pairing-status]');
      this.cartLink = this.querySelector('[data-pairing-cart]');
      this.variants = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
      this.selects = [...this.querySelectorAll('[data-pairing-option]')];
      this.form.addEventListener('change', () => this.update(), {signal: this.abort.signal});
      this.form.addEventListener('submit', event => this.add(event), {signal: this.abort.signal});
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); this.abort = null; }
    update() {
      const values = this.selects.map(select => select.value);
      this.variant = this.dataset.fixedVariant
        ? this.variants.find(variant => String(variant.id) === this.dataset.fixedVariant)
        : values.every(Boolean) && this.variants.find(variant => variant.options.every((value, index) => value === values[index]));
      this.form.elements.id.value = this.variant?.id || '';
      this.button.disabled = this.busy || !this.variant?.available;
      this.button.textContent = this.busy ? this.dataset.adding : !this.variant ? this.dataset.choose : this.variant.available ? this.dataset.add : this.dataset.soldOut;
      if (this.variant) {
        this.querySelector('[data-pairing-price]').textContent = this.variant.price;
        const image = this.querySelector('[data-pairing-image]');
        if (image && this.variant.image) { image.removeAttribute('srcset'); image.src = this.variant.image; }
      }
      if (!this.busy) this.status.textContent = '';
    }
    async add(event) {
      event.preventDefault();
      if (this.busy || !this.variant?.available || !this.form.reportValidity()) return;
      const variantId = Number(this.variant.id);
      const drawer = document.querySelector('hdt-cart-drawer[ref="hdt-cart"]');
      const sectionId = drawer?.getAttribute('section-id');
      this.busy = true;
      this.update();
      this.button.setAttribute('aria-busy', 'true');
      this.cartLink.hidden = true;
      this.status.textContent = '';
      let message = '', confirmed = false;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const body = {items: [{id: variantId, quantity: 1}], sections_url: window.location.pathname};
        if (sectionId) body.sections = [sectionId];
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify(body)
        });
        const data = await response.json();
        if (!response.ok || data.status) {
          message = typeof data.description === 'string' ? data.description : this.dataset.error;
        } else {
          confirmed = true;
          message = this.dataset.added;
          if (sectionId && data.sections?.[sectionId]) {
            this.dispatchEvent(new CustomEvent('cart:update', {bubbles: true, detail: {
              resource: {}, sourceId: String(variantId), cartData: data,
              actionAfterATC: 'open_cart_drawer', source: 'product-form-component',
              data: {itemCount: 1, productId: this.dataset.productId, sections: data.sections}
            }}));
          } else {
            document.dispatchEvent(new CustomEvent('cart:reload'));
          }
        }
      } catch {
        message = confirmed ? this.dataset.added : this.dataset.unknown;
        this.cartLink.hidden = false;
      } finally {
        this.busy = false;
        this.update();
        this.button.removeAttribute('aria-busy');
        this.status.textContent = message;
        if (confirmed) this.cartLink.hidden = false;
      }
    }
  }
  customElements.define('gp-pairing-card', PairingCard);
})();
